import { EDITOR_ROLES } from "@shared/core/types";
import type { WebModule } from "../../core/modules";
import { CandidatesList } from "./routes/list";
import { CandidateNew } from "./routes/new";
import { CandidateDetail } from "./routes/detail";

const xCandidats: WebModule = {
  name: "x-candidats",
  routes: [
    { path: "/candidats", element: <CandidatesList /> },
    { path: "/candidats/nouveau", element: <CandidateNew />, roles: EDITOR_ROLES },
    { path: "/candidats/:id", element: <CandidateDetail /> },
  ],
  nav: [
    {
      title: "Recrutement",
      order: 10,
      items: [
        { to: "/candidats", label: "Dossiers candidats", icon: "list", end: true },
        { to: "/candidats/nouveau", label: "Nouveau dossier", icon: "plus", end: true, roles: EDITOR_ROLES },
      ],
    },
  ],
};

export default xCandidats;
